export default __webpack_public_path__ + "static/IN-9408WQHD-vs-IN-9008FHD_day2-f04c6687971bc50b84415045455fe86f.webp";